export default __webpack_public_path__ + "static/media/up-arrow-tip-jar.870e43c1.svg";